module.exports = __webpack_public_path__ + "img/u12.3b1926a5.png";